export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons-react/es/index.js
// module id = 304
// module chunks = 3